exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".area-chart .xAxis .tick text[data-v-d6f23b5e] {\n  fill: #7f8080;\n  font-size: 10px;\n}\n.area-chart .xAxis .tick line[data-v-d6f23b5e] {\n  stroke: #006BB0;\n}\n.area-chart .xAxis .domain[data-v-d6f23b5e] {\n  stroke: #B5B6B5;\n}\n.area-chart .yAxis .tick text[data-v-d6f23b5e] {\n  fill: #7f8080;\n  font-size: 10px;\n}\n.area-chart .yAxis .tick line[data-v-d6f23b5e] {\n  stroke: #F5F4F4;\n}\n.area-chart .yAxis .domain[data-v-d6f23b5e] {\n  display: none;\n}\n.area-chart circle[data-v-d6f23b5e] {\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n}", ""]);

// exports
